export type ButtonVariant =
  | "default"
  | "red"
  | "light"
  | "outline"
  | "arrow"
  | "arrow-reverse";

const variantClasses: Record<ButtonVariant, string> = {
  default: "btn",
  red: "btn btn-red",
  light: "btn btn-light",
  outline: "btn btn-outline",
  arrow: "btn btn-arrow",
  "arrow-reverse": "btn btn-arrow-reverse",
};

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  children: React.ReactNode;
}

export default function Button({
  variant = "default",
  children,
  className,
  ...props
}: ButtonProps) {
  return (
    <button
      {...props}
      className={`${variantClasses[variant]} ${className ?? ""} group relative overflow-hidden`}
    >
      <ContentButton>{children}</ContentButton>
    </button>
  );
}

export function ContentButton({ children }: { children: React.ReactNode }) {
  return (
    <>
      <span className="group-hover:translate-y-[-2rem] transition-all ease-out duration-200 block group-hover:opacity-0">
        {children}
      </span>
      <span className="translate-y-[2rem] group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all ease-out duration-200 block absolute left-3 top-2">
        {children}
      </span>
    </>
  );
}
